import { render, staticRenderFns } from "./TestTopics.vue?vue&type=template&id=30753862"
import script from "./TestTopics.vue?vue&type=script&lang=js"
export * from "./TestTopics.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports